module.exports = __webpack_public_path__ + "static/img/m_download_dashed1@3x.dece7e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_download_dashed1@3x.png
// module id = 987d
// module chunks = 1